import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../styles";

type OrgSettingsTableRowProps = {
  setting: {
    key: string;
    value: string;
    entity: string;
  };
};

export const OrgSettingsTableRow = (props: OrgSettingsTableRowProps) => {
  const { setting } = props;
  const classes = mainStyles();
  return (
    <TableRow data-testid="org-settings-table-row">
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {setting.key}
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {setting.value}
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.tableRightColPadding)}
        align="left"
      >
        {setting.entity}
      </TableCell>
    </TableRow>
  );
};
